// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"20a307c9","551":"8c8ad39a","842":"8df647c5"}[chunkId] + ".chunk.js";
};